import React from 'react'
import {
  Card,
  CardBody,
  Flex,
  Heading,
  Image,
  VStack
} from '@chakra-ui/react'
import PriceDisplay from './PriceDisplay'
import RefreshButton from './RefreshButton'
import { CoinData } from '../types'

interface CoinHeaderProps {
  data: CoinData
  onRefresh: () => void
  isRefreshing: boolean
  cardBg: string
  borderColor: string
}

const CoinHeader = ({ data, onRefresh, isRefreshing, cardBg, borderColor }: CoinHeaderProps) => (
  <Card
    mb={6}
    bg={cardBg}
    borderWidth={1}
    borderColor={borderColor}
    boxShadow="md"
    overflow="hidden"
  >
    <CardBody>
      <Flex
        direction={{ base: 'column', md: 'row' }}
        align={{ base: 'center', md: 'center' }}
        justify="space-between"
        wrap="wrap"
        gap={4}
      >
        <Flex align="center" gap={4}>
          {data.image && (
            <Image
              src={data.image.large}
              alt={data.name}
              boxSize={{ base: '60px', md: '80px' }}
              objectFit="contain"
            />
          )}
          <VStack align="flex-start" spacing={0}>
            <Heading size="lg">{data.name}</Heading>
            <PriceDisplay 
              price={data.market_data.current_price.usd}
              priceChangePercentage={data.market_data.price_change_percentage_24h}
              symbol={data.symbol}
            />
          </VStack>
        </Flex>

        <RefreshButton onRefresh={onRefresh} isRefreshing={isRefreshing} />
      </Flex>
    </CardBody>
  </Card>
)

export default CoinHeader
